import React from 'react';
import PropTypes from "prop-types";

const Alert = props => (
    <div className="popup">
        <div className="btn-close">
            <button className="btn btn-link" onClick={() => props.closeModal('delete')}><i className="icon-close"> </i></button>
        </div>
        <div className="container">
            <div className="row justify-content-center">
                <form className="col-md-8">
                    <div className="form-title">
                        <h1>Are you sure?</h1>
                    </div>
                    <div className="text-center">
                        <button className="btn btn-lg btn-primary mr-3" onClick={() => props.closeModal('delete', true)}>yes</button>
                        <button className="btn btn-lg btn-secondary" onClick={() => props.closeModal('delete')}>no</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

);

Alert.propTypes = {
    closeModal: PropTypes.func.isRequired
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/popups/Alert.jsx